import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useFetchPreexistence } from "../../common/services/sanitas/apiSanitasPreexistence";
import Loading from "../../components/elements/loading";

const ImageBannerContract = "/documents/d/guest/Group-7923-2";

const MedicalConditionsForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const payload = location.state?.payload;
    const medicalConditionForm = payload.medicalConditionForm;console.log(payload);
    const codeMember = payload?.memberCode;
    const [diagnosticName , setDiagnosticName] = useState<string[]>([]);

    const {data, isLoading} = useFetchPreexistence(payload.identityDocumentTypeId, payload.identityDocument, codeMember);

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if(data){
            const names = data.flatMap((item: any) => {
                return medicalConditionForm.diagnostics
                    .filter((condition: any) => condition.diagnosticId === item.diagnosticId)
                    .map(() => item.diagnosticName);
            });
            setDiagnosticName(names);
        }
    }, [data]);

    const formattedDiagnosticName = () => {
        return diagnosticName.map((item, index) => (
            <div key={index} className="info_inputetiquet">
                <div>{item}</div>
            </div>
        ));
    }

    if (isLoading) return <Loading />;

    return (
        <>
            <section className="hero">
                <div className="padding-global">
                    <div className="padding-section-small">
                        <div className="container-medium">
                            <div className="hero_wrp">
                                <div className="hero_box is-ajuste">
                                    <div className="title-component">
                                        <h1 className="title">Condiciones medicas</h1>
                                        <div className="line-title"></div>
                                    </div>
                                </div>
                                <img
                                    src={ImageBannerContract}
                                    loading="lazy"
                                    alt=""
                                    className="banner_person"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="perfil-t">
                <div className="padding-global">
                    <div className="padding-section-medium">
                        <div className="container-large">
                            <div className="info_wrp">
                                <div className="form_content is-condiciones">
                                    <div className="info_inputs w-form">
                                        <form
                                            id="formSetting"
                                            name="email-form"
                                            data-name="Email Form"
                                            method="get"
                                            className="info_form is-condiciones"
                                            data-wf-page-id="66eb20cf3dc6660a46df3a7d"
                                            data-wf-element-id="5f6eda8f-2c83-ca3f-c4ec-3265edc951c1"
                                        >
                                            <div id="w-node-_5f6eda8f-2c83-ca3f-c4ec-3265edc951c6-46df3a7d" className="info_row">
                                                <div className="info_input-bx is-border">
                                                    <input
                                                        className="info_inputv w-input"
                                                        maxLength={256}
                                                        name="field-7"
                                                        data-name="Field 7"
                                                        placeholder=""
                                                        type="text"
                                                        id="field-7"
                                                        disabled
                                                        value={medicalConditionForm.programName}
                                                    />
                                                    <div className="info_input-text al-frente">Tipo de condición</div>
                                                </div>
                                                <div className="info_input-bx is-border">
                                                    <input
                                                        className="info_inputv w-input"
                                                        maxLength={256}
                                                        name="field-7"
                                                        data-name="Field 7"
                                                        placeholder=""
                                                        type="text"
                                                        id="field-7"
                                                        disabled
                                                        value={medicalConditionForm.conditionDateCustom}
                                                    />
                                                    <div className="info_input-text al-frente">Fecha de condición</div>
                                                </div>
                                                <div className="info_input-bx is-border">
                                                    <input
                                                        className="info_inputv w-input"
                                                        maxLength={256}
                                                        name="field-7"
                                                        data-name="Field 7"
                                                        placeholder=""
                                                        type="text"
                                                        id="field-7"
                                                        required
                                                        disabled
                                                        value={medicalConditionForm.statusName}
                                                    />
                                                    <div className="info_input-text al-frente">Estado</div>
                                                </div>
                                            </div>
                                            <div className="info_input-bx is-seleccionableetiquetas">
                                                <div className="info_input-text al-frente">CIE10</div>
                                                <div className="info_inputv is-etiquet">
                                                    {formattedDiagnosticName()}
                                                </div>
                                            </div>
                                            <div className="info_input-bx is-border">
                                                <input
                                                    className="info_inputv w-input"
                                                    maxLength={256}
                                                    name="field-7"
                                                    data-name="Field 7"
                                                    placeholder=""
                                                    type="text"
                                                    id="field-7"
                                                    required
                                                    disabled
                                                    value={medicalConditionForm.ipressSedeName}
                                                />
                                                <div className="info_input-text al-frente">Ipress Tratante</div>
                                            </div>
                                            <div className="info_input-bx is-border is-area">
                                                <textarea
                                                    placeholder=""
                                                    maxLength={5000}
                                                    id="field-5"
                                                    name="field-5"
                                                    data-name="Field 5"
                                                    className="info_inputv is-area w-input"
                                                    disabled
                                                    value={medicalConditionForm.comment}
                                                ></textarea>
                                                <div className="info_input-text al-frente">Comentarios</div>
                                            </div>
                                            <div className="info_boxing is-left">
                                                <a onClick={handleBack} className="button is-outline w-button">Atrás</a>
                                            </div>
                                        </form>
                                        <div className="w-form-done">
                                            <div>Thank you! Your submission has been received!</div>
                                        </div>
                                        <div className="w-form-fail">
                                            <div>Oops! Something went wrong while submitting the form.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default MedicalConditionsForm;